import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './pubic/output.css';

import Hero from "./components/hero.js"
import StickyMenu from "./components/stickymenu.js";
import Announcement from "./components/announcements.js";
import Mockups from "./components/mockups.js";
import Features from "./components/features.js"
import Footer from "./components/footer.js"

import decentixLogo from "./assets/images/splashdecentixlogo.png"; // Adjust the path if needed
import kendrickPhone from "./assets/images/kendrickphone.png"; // Adjust the path if needed
import searchPhone from "./assets/images/searchphone.png"; // Adjust the path if needed
import shoheiPhone from "./assets/images/shoheiphone.png"; // Adjust the path if needed
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonFab,
  IonFabButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonActionSheet,
} from '@ionic/react';
import { Helmet } from 'react-helmet';


import { useState, useEffect } from "react";


//const root = ReactDOM.createRoot(document.getElementById('root'));

//root.render(
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = './public/output.css'; // Path may vary depending on your build setup
document.head.appendChild(link);

{/*good job :)*/}

function Test(){
  return(
    <div className="bg-red-500 text-white p-4">
  Tailwind Test — This should be RED
</div>
  )
}

function Homepage() {
  return (
    <div className="Homepage">
    <Helmet>
      <title>Decentix | The Open Market for Tickets.</title>
      </Helmet>
      <Hero />
      <Announcement />
      <Mockups/>
      <Features />
      <Footer />
    </div>
  );
}


export default Homepage;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Homepage />);

  /*<React.StrictMode>
    <App />
  </React.StrictMode>*/
//);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
